import ViewBase from "../../../../framework/core/mvvm/view_base";
import MVVMBase from "../../../../framework/core/mvvm/mvvm_base";
import { TaskBase } from "./com/task_base";
import SpriteFrameHolder from "../../../public/ui/spriteFrameHolder";
const {ccclass, property} = cc._decorator;

@ccclass
export default class TaskView extends ViewBase {
    
    @property([cc.Toggle])
    toggles:cc.Toggle[] = [];

    @property(TaskBase)
    allTask:TaskBase[] = []

    initView(mvvm:MVVMBase){
        for (let i = 0; i < this.allTask.length; i++) {
            let task = this.allTask[i];
            task.init(mvvm);
        }
    }

    changeTaskPanel(toggle:cc.Toggle,finish?:Function){
        for (let i = 0; i < this.allTask.length; i++) {
            let task = this.allTask[i];
            task.changePanel(toggle,finish)
        }
    }

    clickToggle(index:number){
        this.toggles[index].node.emit('toggle');
        this.toggles[index].check();
    }

    on_destroy(){
        for (let i = 0; i < this.allTask.length; i++) {
            let task = this.allTask[i];
            task.clear();
        }
    }

    hide(){
        for (let i = 0; i < this.allTask.length; i++) {
            let task = this.allTask[i];
            task.hide()
        }
    }
}
